<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form inline class="inline-form">
          <el-form-item label="返佣时间">
            <date-range-picker v-model="creatTime" :value="creatTime" ref="creatTime" @getChange="dateChange"></date-range-picker>
          </el-form-item>
          <el-form-item label="商户编号">
            <el-select
              class="search-input"
              v-model="merchantId"
              placeholder="模糊搜索"
              clearable
              filterable
              remote
              :remote-method="handleMerchantInfoRemote"
              :loading="selectLoading">
              <el-option
                v-for="item in subMerchantNamesList"
                :key="item.fmerchantId"
                :label="item.fmerchantId"
                :value="item.fmerchantId">
                <span class="value">{{ item.fmerchantId }}</span>
                <span class="name">{{ item.fmerchantName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下级代理商" v-if="!isInstitution">
            <el-select
              class="search-input"
              v-model="subAgentId"
              placeholder="模糊搜索"
              clearable
              filterable
              :filter-method="handleAgentInfoFilter">
              <el-option
                v-for="item in subAgentInfoList"
                :key="item.fAgentId"
                :label="item.fAgentId"
                :value="item.fAgentId">
                <span class="value">{{ item.fAgentId }}</span>
                <span class="name">{{ item.fTitle }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询" :loading="searchButtonLoading"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- table -->
      <el-table
        stripe
        style="width:100%;"
        v-loading="tableLoading"
        :data="profitDetailList"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="fcreateTime"
          label="返佣时间"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="fmerchantId"
          label="商户编号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="merchantName"
          label="直属代理商编号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="fagentId"
          label="返佣金额"
          align="center"
          v-if="isInstitution"
          min-width="200">
        </el-table-column>
      </el-table>
    </el-card>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
  </div>
</template>

<script>
import qs from 'qs'
import { parseTime } from '@/utils/formatTime'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { listAgentMerchant, directSubAgentInfo } from '@/api/transaction'
import { querySale } from '@/api/partner'
import { listProfitDetail, exportProfitDetail, listCustomerProfitDetail, exportCustomerProfitDetail } from '@/api/settle'
const selectFn = {
  listProfitDetail, exportProfitDetail, listCustomerProfitDetail, exportCustomerProfitDetail
}
export default {
  name: 'ProfitDetail',
  components: {
    dateRangePicker,
    pagination
  },
  data () {
    const todayStr = (parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')).substr(0, 10) + ' 23:59:59'
    const toadyZero = new Date(new Date().getTime() - 3600 * 1000 * 7 * 30)
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d} {h}:{i}:{s}').substr(0, 10) + ' 00:00:00'
    return {
      loading: false,
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 20
      },
      // 搜索表单信息
      searchInfo: {
        startTime: '',
        endTime: '',
        agentId: '',
        merchantId: '',
        orderId: '',
        operatorAccount: '',
        payType: 0,
        effectPayTypeStr: '2,3,6',
        customerId: ''
      },
      creatTime: [todayZeroStr, todayStr],
      subAgentId: '',
      operatorAccount: '',
      merchantId: '',
      orderId: '',
      tableLoading: false,
      selectLoading: false,
      exportButtonLoading: false,
      subMerchantNamesList: [],
      subAgentInfoList: [],
      subAgentInfoList_back: [],
      saleInfoList: [],
      saleInfoList_back: [],
      profitDetailList: [],
      totalInfo: {},
      showAdapt: false, // 是否显示代收费用，只有超盟显示
      interval: '', // 导出限制计时器
      times: 5,
      agentId: '',
      disabledExport: false, // 禁止导出
      isInstitution: this.$store.getters.roleId === 10,
      searchButtonLoading: false
    }
  },
  mounted () {
    if (this.$store.getters.userInfo.userEntity.fAgentGrandpaId === '3233605') {
      this.showAdapt = true
    }
    this.getDefaultData()
    if (this.roleName !== 'operator') {
      this.getSubAgentInfo()
      this.querySaleList()
    }
  },
  created () {
    const user = JSON.parse(localStorage.getItem('ZZGAgentUser'))
    if (user && user.userEntity && user.userEntity.fAgentId) {
      this.agentId = JSON.parse(localStorage.getItem('ZZGAgentUser')).userEntity.fAgentId
      const time = localStorage.getItem('EXPORT_PROFIT_TIME_' + this.agentId)
      if (time) {
        const now = new Date()
        // 计算时间是否已经超过5s
        if (now - time > 5 * 1000) {
          localStorage.removeItem('EXPORT_PROFIT_TIME_' + this.agentId)
        } else {
          this.disabledExport = true
          this.times = 5 - Math.floor((now - time) / 1000)
          this.countdown()
        }
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    /**
     * 初始加载数据方法
     */
    async getDefaultData () {
      this.loading = true
      // await this.getAllSubMerchantNames()
      !this.isInstitution && await this.searchClick()
      this.loading = false
    },
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    /**
     * @description 筛选查询按钮点击
     */
    searchClick (noReset) {
      console.log('查询点击')
      this.setSearchInfoParams(noReset)
      this.listProfitDetail()
    },
    /**
     * 导出按钮点击
     */
    exportClick () {
      console.log('导出点击')
      this.setSearchInfoParams(true)
      // const startDate = new Date(this.searchInfo.startTime)
      // const endDate = new Date(this.searchInfo.endTime)
      // if (!this.searchInfo.startTime || !this.searchInfo.endTime || endDate.getTime() - startDate.getTime() > 3600 * 1000 * 24 * 30) {
      if (!this.searchInfo.startTime || !this.searchInfo.endTime) {
        this.$message({
          // message: '请筛选1个月内的数据进行导出',
          message: '请筛选时间进行导出',
          type: 'error'
        })
        return
      }
      if (this.isInstitution && !this.searchInfo.customerId) {
        this.$message({
          message: '请先输入机构编号',
          type: 'error'
        })
        return
      }
      this.toExportProfitDetail()
    },
    /**
     * 组装筛选参数
     */
    setSearchInfoParams (noReset) {
      this.searchInfo.startTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchInfo.endTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      this.searchInfo.agentId = this.isInstitution ? this.searchInfo.agentId : (this.subAgentId || '')
      this.searchInfo.merchantId = this.merchantId.replace(/ /g, '') || ''
      this.searchInfo.orderId = this.orderId.replace(/ /g, '') || ''
      this.searchInfo.operatorAccount = this.operatorAccount.replace(/ /g, '') || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      Object.assign(this.searchInfo, this.paginations)
    },
    queryBelongsMerchantSearch (queryString, cb) {
      var merchantList = []
      var arr
      for (var x = 0; x < this.subMerchantNamesList.length; x++) {
        arr = { value: this.subMerchantNamesList[x].code, name: this.subMerchantNamesList[x].name }
        merchantList.push(arr)
      }
      console.log(merchantList)
      var results = queryString ? merchantList.filter(this.createFilter(queryString)) : merchantList
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1) || (restaurant.name.indexOf(queryString) !== -1)
      }
    },
    /**
     * @description 删除提交参数中的空字段
     * @param {Object} params 搜索内容对象
     */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
     * @description 直属代理商根据输入内容返回输入建议的方法
     * @param {String} queryString 内容字符串
     * @param {Function} cb 回调函数，接收搜索结果数据
     */
    async querySubAgentSearch (queryString, cb) {
      if (this.subAgentInfoList.length === 0) {
        await this.getSubAgentInfo()
      }
      const userInfo = JSON.parse(localStorage.getItem('ZZGAgentUser')).userEntity
      const agentList = [{
        value: userInfo.fAgentId,
        name: userInfo.fName
      }]
      this.subAgentInfoList.forEach(element => {
        agentList.push({
          value: element.fAgentId,
          name: element.fName
        })
      })
      const results = queryString ? agentList.filter(this.createSubAgentFilter(queryString)) : agentList
      cb(results)
    },
    /**
     * @description 根据输入内容进行筛选方法
     * @param {String} queryString 内容字符串
     */
    createSubAgentFilter (queryString) {
      return (agentList) => {
        return (agentList.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1) || (agentList.name.indexOf(queryString) !== -1)
      }
    },
    /**
     * 直属代理商自定义筛选方法
     */
    handleAgentInfoFilter (queryString) {
      if (queryString) {
        this.subAgentInfoList = this.subAgentInfoList_back.filter(item => {
          return item.fAgentId.toLowerCase().includes(queryString.toLowerCase()) || item.fTitle.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.subAgentInfoList = this.subAgentInfoList_back
      }
    },
    /**
     * 业务员账号自定义筛选方法
     */
    handleSalesInfoFilter (queryString) {
      if (queryString) {
        this.saleInfoList = this.saleInfoList_back.filter(item => {
          return item.fAgentAccount.toLowerCase().includes(queryString.toLowerCase()) || item.fName.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.saleInfoList = this.saleInfoList_back
      }
    },
    /**
     * 商户信息自定义筛选方法
     */
    async handleMerchantInfoRemote (queryString) {
      if (queryString) {
        this.selectLoading = true
        await this.getListAgentMerchant(queryString)
        this.selectLoading = false
      } else {
        this.subMerchantNamesList = []
      }
    },
    /**
     * 获取代理商下所有商户列表
     */
    getListAgentMerchant (merchantId) {
      const params = qs.stringify({
        merchantName: merchantId,
        pageNo: 1,
        pageSize: 50
      })
      console.log(params)
      return new Promise((resolve, reject) => {
        listAgentMerchant(params).then(response => {
          console.log('listAgentMerchant response:', response)
          if (parseInt(response.result_cde) === 0) {
            this.subMerchantNamesList = response.list
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.result_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    /**
     * @description 获取下级代理商下拉列表
     */
    getSubAgentInfo () {
      return new Promise((resolve, reject) => {
        // 设一个超大的pageSize取所有数据
        directSubAgentInfo('pageSize=655350').then(response => {
          console.log('getDirectSubAgentInfo response:', response)
          if (response.error_code === '0') {
            const userInfo = JSON.parse(localStorage.getItem('ZZGAgentUser')).userEntity
            const agentList = [{
              fAgentId: userInfo.fAgentId,
              fTitle: userInfo.fTitle
            }]
            this.subAgentInfoList = agentList.concat(response.list)
            this.subAgentInfoList_back = [...this.subAgentInfoList]
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    /**
     * 获取业务员下拉列表
     */
    querySaleList () {
      return new Promise((resolve, reject) => {
        // 设一个超大的pageSize取所有数据
        querySale('pageSize=65535').then(response => {
          console.log('querySale response:', response)
          if (response.error_code === '0') {
            this.saleInfoList = response.list
            this.saleInfoList_back = [...this.saleInfoList]
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    /**
     * 分润明细
     */
    listProfitDetail () {
      // const startDate = new Date(this.searchInfo.startTime)
      // const endDate = new Date(this.searchInfo.endTime)
      // if (endDate.getTime() - startDate.getTime() > 3600 * 1000 * 24 * 30) {
      //   this.$message({
      //     message: '请筛选1个月内的交易进行查询',
      //     type: 'error'
      //   })
      //   return
      // }
      if (this.isInstitution && (!this.searchInfo.startTime || !this.searchInfo.endTime)) {
        this.$message({
          message: '请选择时间进行查询',
          type: 'error'
        })
        return
      }
      if (this.isInstitution && !this.searchInfo.customerId) {
        this.$message({
          message: '请先输入机构编号',
          type: 'error'
        })
        return
      }
      const params = qs.stringify(this.searchInfo)
      console.log(params)
      this.searchButtonLoading = true
      const url = this.isInstitution ? 'listCustomerProfitDetail' : 'listProfitDetail'
      selectFn[url](params).then(response => {
        this.searchButtonLoading = false
        console.log('listProfitDetail response:', response)
        this.loading = false
        if (parseInt(response.result_cde) === 0) {
          this.profitDetailList = response.list
          this.paginations.count = response.totalCount
          this.totalInfo = {
            totalAmountStr: response.totalAmountStr,
            totalProfitStr: response.totalProfitStr,
            directMerchantProfitStr: response.directMerchantProfitStr,
            subMerchantProfitStr: response.subMerchantProfitStr,
            extraSubAgentProfitStr: response.extraSubAgentProfitStr,
            subAgentProfitStr: response.subAgentProfitStr,
            totalSelfProfitStr: response.totalSelfProfitStr,
            totalProfitAdaptStr: response.totalProfitAdaptStr
          }
          if (parseInt(this.paginations.count) > 10000) {
            this.$message({
              message: '最多筛选出10000条数据，请重新筛选',
              type: 'warning'
            })
          }
        } else {
          this.$message({
            message: response.result_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 分润明细导出
     */
    toExportProfitDetail () {
      if (this.disabledExport) return
      this.exportButtonLoading = true
      const params = qs.stringify(Object.assign({}, this.searchInfo, {
        moduleCode: 4,
        moduleName: '分润',
        menuName: '分润明细'
      }))
      console.log(params)
      const url = this.isInstitution ? 'exportCustomerProfitDetail' : 'exportProfitDetail'
      selectFn[url](params).then(response => {
        this.exportButtonLoading = false
        this.disabledExport = true
        // 5s内不允许导出
        this.countdown()
        localStorage.setItem('EXPORT_PROFIT_TIME_' + this.agentId, Date.now())
        if (parseInt(response.result_cde) === 0) {
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success'
          })
        } else {
          this.$message({
            message: response.result_msg,
            type: 'error'
          })
        }
      })
    },
    formatDate (item) {
      return parseTime(new Date(item.fTime), '{y}-{m}-{d} {h}:{i}:{s}')
    },
    // 获取组件中交易类型及交易渠道选中值
    getPayType (val) {
      this.searchInfo.payType = val
    },
    getEffectPayType (val) {
      this.searchInfo.effectPayTypeStr = val.trim()
    },
    dateChange (value) {
      this.creatTime = value
    },
    countdown () {
      this.interval = setInterval(() => {
        if (this.times > 1) {
          this.times = this.times - 1
        } else {
          this.times = 5
          clearInterval(this.interval)
          this.disabledExport = false
        }
      }, 1000)
    }
  },
  computed: {
    roleName () {
      return this.$store.getters.roleName
    }
  },
  filters: {
    formatFState (value) {
      switch (value) {
        case 0:
          return '初始化状态'
        case 1:
          return '金额冻结成功'
        case 2:
          return '金额冻结失败'
        case 3:
          return '冻结结果未知'
        case 4:
          return '商户打款被冻结'
        case 5:
          return '被拦截<未发起付款>'
        case 6:
          return '打款中'
        case 14:
          return '金额解冻结果未知'
        case 15:
          return '退票成功'
        case 16:
          return '退票失败'
        case 17:
          return '退票结果未知'
        case 18:
          return '打款单被合并'
        case 19:
          return '提交打款失败，允许重新打款'
        case 20:
          return '申请退票'
        case 7:
          return '付款成功'
        case 8:
          return '付款失败'
        case 9:
          return '金额解冻转账成功'
        case 10:
          return '金额解冻转账失败'
        case 11:
          return '金额解冻转账结果未知'
        case 12:
          return '金额解冻成功'
        case 13:
          return '金额解冻失败'
      }
    }
  }
}
</script>

<style scoped>
.main-view {
  padding-left: 16px;
}
.search-input {
  width: 160px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.sum-view {
  margin: 10px;
  text-align: center;
  font-size: 14px;
  display: flex;
  justify-items: center;
  justify-content: space-around;
}
.sum-item-title {
  font-weight: 700;
  margin-bottom: 30px;
}
.tip-view {
  margin: 10px;
  font-size: 14px;
}
</style>
